/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {Button, Typography} from 'onboarding-components';
import {clsx} from 'clsx';

import {SvgIconReact} from 'common/components/svg-icon';

import styles from '../index.module.styl';
import {SetupGuideContext, Step} from '../types';
import {ScrollableLink} from './scroll-manager';

const StepIndicator = ({isCompleted, moniker, children, step: targetStep}) => {
  const {step} = React.useContext(SetupGuideContext);

  return (
    <ScrollableLink className={clsx({[styles.completed]: isCompleted}, styles.indicator)} targetStep={targetStep}>
      {isCompleted ? (
        <div className={clsx(styles.moniker, styles.completed, {[styles.current]: step === targetStep})}>
          <SvgIconReact icon='checkmark' />
        </div>
      ) : (
        <div className={clsx(styles.moniker, {[styles.current]: step === targetStep})}>{moniker}</div>
      )}
      <Typography variant='bodySm'>{children}</Typography>
    </ScrollableLink>
  );
};

export const SideNav = ({onClose}) => {
  return (
    <>
      <div className={styles.nav}>
        <div>
          <Typography variant='headingMd' style={{margin: 0}}>{`Set Up Guide`}</Typography>
          <Typography variant='bodySm' className={styles.subtitle}>{`Up and running in 20 minutes`}</Typography>
          <div className={styles.indicatorGroup}>
            {/* Replace with components */}
            <StepIndicator isCompleted={false} moniker={<SvgIconReact icon='fire' />} step={Step.Welcome}>
              Welcome
            </StepIndicator>
            <StepIndicator isCompleted={true} moniker={1} step={Step.Events}>
              Personalize your setup
            </StepIndicator>
            <StepIndicator isCompleted={false} moniker={2} step={Step.Implement}>
              Send your data
            </StepIndicator>
            <StepIndicator isCompleted={false} moniker={3} step={Step.Explore}>
              Explore product insights
            </StepIndicator>
          </div>
        </div>
        <Button onClick={onClose} variant='inline' color='dark' className={styles.footerButton}>
          Skip and continue later
        </Button>
      </div>
    </>
  );
};
